
(function ($) {
  'use strict';

  /**
   * Site javascripts
   */


  /**
   * Popup Test
   */
  // $('#js-open-popup').magnificPopup({
  //   type: 'inline',
  // });




  var $buttons = $('a.grad-button');

  $buttons.each(function () {
    var $this = $(this);

    if ( ! $this.has( 'span' ).length ) {
      $this.wrapInner( '<span></span>' );
    }
  });



  /**
   * Fancy Number Ticker
   */
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  if ( $('.odometer').length ) {
    $(window).on('resize scroll', function () {
      $('.odometer').each( function () {
        var $this = $(this);
        var end_number = $this.data( 'animate-number' );

        if ( $this.isInViewport() ) {
          setTimeout(function () {
            $this.html( end_number );
          }, 250 );
        }
      });
    }).resize();
  }


  $('.vid-button').magnificPopup({type: 'iframe'});
  $('.vid-button-button').magnificPopup({type: 'iframe'});

  // Popups

  $('.js-pop-link').magnificPopup({
    type: 'inline',
  });

  $('.js-no-pop').on('click', function () {
    return false;
  });

  $('.js-pop-button').magnificPopup({
    type: 'inline',
  });

  $('.home-blog-body a[href*="youtube.com"]').magnificPopup({
    type: 'iframe'
  });

  $('.card-pop-link').magnificPopup({
    type: 'inline',
  });


  // Wrap video embeds in Flexible Container
  $('iframe[src*="youtube.com"]:not(.not-responsive), iframe[src*="vimeo.com"]:not(.not-responsive)')
    .attr( 'frameborder', 0 )
    .wrap('<div class="flexible-container"></div>');

  // Resize Maps
  $('iframe[src*="google.com/map"]:not(.not-responsive)')
    .attr( 'frameborder', 0 )
    .wrap('<div class="flexible-container"></div>');


  var $owl_carousel = $('.js-owl-carousel');

  $owl_carousel.each(function () {
    var $this = $(this);
    var carousel_loop = false;
    var carousel_nav  = false;
    var carousel_dots = false;
    var mouse_drag    = false;
    var touch_drag    = false;

    if ( $this.find( '> div' ).length > 1 ) {
      carousel_loop = true;
      carousel_nav  = true;
      carousel_dots = true;
      mouse_drag    = true;
      touch_drag    = true;
    }

    // Carousels
    $this.owlCarousel({
      items: 1,
      mouseDrag: mouse_drag,
      touchDrag: touch_drag,
      dots: carousel_dots,
      nav: carousel_nav,
      loop: carousel_loop,
      navSpeed: 500,
      dotsSpeed: 500,
      dragEndSpeed: 500,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 5200,
      animateIn: 'anIn',
      animateOut: 'anOut',
      navText: [
        '<svg class="svg-left-icon" width="16" height="19"><use href="#arrow-left-icon"/>',
        '<svg class="svg-right-icon" width="16" height="19"><use href="#arrow-right-icon"/>',
      ]
    });
  });


  $('.js-mosaic-carousel').each(function () {
    var $this = $(this);
    var carousel_nav  = false;

    if ( $this.find( '> div' ).length > 1 ) {
      carousel_nav  = true;
    }

    // Carousels
    $this.owlCarousel({
      dots: false,
      nav: true,
      margin: 11,
      loop: false,
      navSpeed: 500,
      dotsSpeed: 500,
      dragEndSpeed: 500,
      autoplayHoverPause: true,
      navText: [
        '<svg class="svg-left-icon" width="16" height="19"><use href="#arrow-left-icon"/>',
        '<svg class="svg-right-icon" width="16" height="19"><use href="#arrow-right-icon"/>',
      ],
      responsive : {
        0 : {
          items : 1,
          nav: false,
        },
        760 : {
          items : 2,
          nav: true,
        },
        960 : {
          items : 3,
          nav: true,
        },
        1350 : {
          items : 4,
          nav: true,
        },
      },
    });
  });


  // Disable empty mosaic links
  $('.mosaic-card a[href="#"]').on('click', function () {
    return false;
  });


    $('.js-quote-carousel').each(function () {
    var $this = $(this);
    var carousel_nav  = true;
    var carousel_loop = true;
    var carousel_dots = true;

    // Carousels
    $this.owlCarousel({
      dots: true,
      nav: false,
      margin: 11,
      loop: true,
      navSpeed: 500,
      dotsSpeed: 500,
      dragEndSpeed: 500,
      autoplayHoverPause: true,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 5200,
      navText: [
        '',
        '',
      ],
      responsive : {
        0 : {
          items : 1,
          nav: false,
        },
        760 : {
          items : 1,
          nav: true,
        },
        960 : {
          items : 1,
          nav: true,
        },
        1350 : {
          items : 1,
          nav: true,
        },
      },
    });
  });



  /**
   * Resource Section
   */

  $('.page-template-template-resources .hs-cta-wrapper .cta_button ')
    .attr('tabindex', '-1')
    .wrapInner('<div class="cta-inner-text"></div>');

  $(window).on('load', function () {
    if ( $('.cta_button').length ) {
      $('.page-template-template-resources .hs-cta-wrapper .cta_button ')
        .attr('tabindex', '-1')
        .wrapInner('<div class="cta-inner-text"></div>');
    }
  });



  /**
   * Custom Selects
   */

  var $custom_select = $('.custom-select');

  $custom_select.selectric();

  $custom_select.on('change', function () {
    var $this_form = $(this).closest( 'form' );
    $this_form.submit();
  });

  // Fix issue with pressing enter on inputs in same form;
  $('.resource-filter-bar input[type="search"]').on('keypress keydown', function (e) {
    if ( e.keyCode == 13 ) {
      $(this).closest('form').submit();
      return false;
    }
  });



  var $animation_trigger_text = $('.slide-up-fade-in');

  $animation_trigger_text.waypoint({
    handler: function ( direction ) {
      if ( direction === 'down' ) {

        var $this = $(this.element);

        if ( ! $this.hasClass( 'slide-up-fade-in-is-animate' ) ) {
          $this.addClass( 'slide-up-fade-in-is-animate' );
        }
      }
    },
    offset: '80%'
  });


  var $animation_trigger_image = $('.slide-down-fade-in');

  $animation_trigger_image.waypoint({
    handler: function ( direction ) {
      if ( direction === 'down' ) {

        var $this = $(this.element);

        if ( ! $this.hasClass( 'slide-down-fade-in-is-animate' ) ) {
          $this.addClass( 'slide-down-fade-in-is-animate' );
        }
      }
    },
    offset: '80%'
  });


  var mouseOutTimeout = 500;
  var mouse_delay = 350;

  var unset_active_delay = 0;
  var mouseleave_timer;
  var delay_timer;
  var first_leave_timer;
  var is_first_leave = false;

  var $max_screen_width = 796;
  var $screen_width = $(window).width();

  $(window).resize(function () {
    $screen_width = $(window).width();
  });

  function show_mega_dropdown( $dropdown_el ) {
    if ( $screen_width > $max_screen_width ) {
      $dropdown_el.addClass('slide-down').removeClass('fadeout');
    }
  }

  function hide_mega_dropdown( $dropdown_el ) {
    if ( $screen_width > $max_screen_width ) {
      $dropdown_el.removeClass('slide-down').addClass('fadeout');
    }
  }

  $('.energy-storage-dropdown').on('mouseenter', function () {
    hide_mega_dropdown( $('#js-mmi--app, #js-mmi--about, #js-mmi--tech') );
    show_mega_dropdown( $('#js-mmi--energy-storage') );
  });
  $('.tech-dropdown').on('mouseenter', function () {
    hide_mega_dropdown( $('#js-mmi--app, #js-mmi--about, #js-mmi--energy-storage') );
    show_mega_dropdown( $('#js-mmi--tech') );
  });
  $('.app-dropdown').on('mouseenter', function () {
    hide_mega_dropdown( $('#js-mmi--tech, #js-mmi--about, #js-mmi--energy-storage') );
    show_mega_dropdown( $('#js-mmi--app') );
  });
  $('.about-dropdown').on('mouseenter', function () {
    hide_mega_dropdown( $('#js-mmi--tech, #js-mmi--app, #js-mmi--energy-storage') );
    show_mega_dropdown( $('#js-mmi--about') );
  });
  $('.product-dropdown').on('mouseenter', function () {
    hide_mega_dropdown( $('#js-mmi--tech, #js-mmi--app, #js-mmi--about, #js-mmi--energy-storage') );
    show_mega_dropdown( $('#js-mmi--product') );
  });

  $('.energy-storage-dropdown, #js-mmi--energy-storage').hover(
    function () {
      mouse_delay = 350;

      clearTimeout( mouseleave_timer );

      show_mega_dropdown( $('#js-mmi--energy-storage') );

      if ( is_first_leave === true ) {
        mouse_delay = 0;
      }

      delay_timer = setTimeout(function () {
        unset_active_delay = mouseOutTimeout;
      }, mouse_delay );

    },
    function () {
      mouseleave_timer = setTimeout(function () {
        hide_mega_dropdown( $('#js-mmi--energy-storage') );
      }, unset_active_delay );

      unset_active_delay = 0;
      clearTimeout( delay_timer );

      is_first_leave = true;

      clearTimeout( first_leave_timer );
      first_leave_timer = setTimeout(function () {
        is_first_leave = false;
      }, 350 );
    }
  );
  $('.tech-dropdown,#js-mmi--tech').hover(
    function () {
      mouse_delay = 350;

      clearTimeout( mouseleave_timer );

      show_mega_dropdown( $('#js-mmi--tech') );

      if ( is_first_leave === true ) {
        mouse_delay = 0;
      }

      delay_timer = setTimeout(function () {
        unset_active_delay = mouseOutTimeout;
      }, mouse_delay );

    },
    function () {
      mouseleave_timer = setTimeout(function () {
        hide_mega_dropdown( $('#js-mmi--tech') );
      }, unset_active_delay );

      unset_active_delay = 0;
      clearTimeout( delay_timer );

      is_first_leave = true;

      clearTimeout( first_leave_timer );
      first_leave_timer = setTimeout(function () {
        is_first_leave = false;
      }, 350 );
    }
  );
  $('.app-dropdown,#js-mmi--app').hover(
    function () {
      mouse_delay = 350;

      clearTimeout( mouseleave_timer );

      show_mega_dropdown( $('#js-mmi--app') );

      if ( is_first_leave === true ) {
        mouse_delay = 0;
      }

      delay_timer = setTimeout(function () {
        unset_active_delay = mouseOutTimeout;
      }, mouse_delay );

    },
    function () {
      mouseleave_timer = setTimeout(function () {
        hide_mega_dropdown( $('#js-mmi--app') );
      }, unset_active_delay );

      unset_active_delay = 0;
      clearTimeout( delay_timer );

      is_first_leave = true;

      clearTimeout( first_leave_timer );
      first_leave_timer = setTimeout(function () {
        is_first_leave = false;
      }, 350 );
    }
  );
  $('.about-dropdown,#js-mmi--about').hover(
    function () {
      mouse_delay = 350;

      clearTimeout( mouseleave_timer );

      show_mega_dropdown( $('#js-mmi--about') );

      if ( is_first_leave === true ) {
        mouse_delay = 0;
      }

      delay_timer = setTimeout(function () {
        unset_active_delay = mouseOutTimeout;
      }, mouse_delay );
    },
    function () {
      mouseleave_timer = setTimeout(function () {
        hide_mega_dropdown( $('#js-mmi--about') );
      }, unset_active_delay );

      unset_active_delay = 0;
      clearTimeout( delay_timer );

      is_first_leave = true;

      clearTimeout( first_leave_timer );
      first_leave_timer = setTimeout(function () {
        is_first_leave = false;
      }, 350 );
    }
  );
  $('.product-dropdown, #js-mmi--product').hover(
    function () {
      mouse_delay = 350;

      clearTimeout( mouseleave_timer );

      show_mega_dropdown( $('#js-mmi--product') );

      if ( is_first_leave === true ) {
        mouse_delay = 0;
      }

      delay_timer = setTimeout(function () {
        unset_active_delay = mouseOutTimeout;
      }, mouse_delay );
    },
    function () {
      mouseleave_timer = setTimeout(function () {
        hide_mega_dropdown( $('#js-mmi--product') );
      }, unset_active_delay );

      unset_active_delay = 0;
      clearTimeout( delay_timer );

      is_first_leave = true;

      clearTimeout( first_leave_timer );
      first_leave_timer = setTimeout(function () {
        is_first_leave = false;
      }, 350 );
    }
  );

//
//   var $link = $(".fart");
//   var $box = $("#box");
//
// $link.mouseenter(function() {
//   clearTimeout($box.data('timeoutId'));
//   $box.show(200);
// }).mouseleave(function() {
//   var timeoutId = setTimeout(function() {
//     $box.hide(200);
//   }, 650);
//   $box.data('timeoutId', timeoutId);
// });
//
// $box.mouseenter(function() {
//   clearTimeout($box.data('timeoutId'));
// }).mouseleave(function() {
//   var timeoutId = setTimeout(function() {
//     $box.hide(200);
//   }, 650);
//   $box.data('timeoutId', timeoutId);
// });



// $(function() {
//     $('.leading-spot').hover(function() {
//         $('.leading-box').fadeIn();
//       },
//       function(){
//         $('.leading-box').fadeOut();
//       }
//    );
// });
//
// $(function() {
//     $('.agile-spot').hover(function() {
//         $('.agile-box').fadeIn();
//       },
//       function(){
//         $('.agile-box').fadeOut();
//       }
//    );
// });
//
// $(function() {
//     $('.resp-spot').hover(function() {
//         $('.resp-box').fadeIn();
//       },
//       function(){
//         $('.resp-box').fadeOut();
//       }
//    );
// });
//
//
// $(function() {
//     $('.fun-spot').hover(function() {
//         $('.fun-box').fadeIn();
//       },
//       function(){
//         $('.fun-box').fadeOut();
//       }
//    );
// });
//
// $(function() {
//     $('.del-spot').hover(function() {
//         $('.del-box').fadeIn();
//       },
//       function(){
//         $('.del-box').fadeOut();
//       }
//    );
// });
//
// $(function() {
//     $('.fier-spot').hover(function() {
//         $('.feir-box').fadeIn();
//       },
//       function(){
//         $('.feir-box').fadeOut();
//       }
//    );
// });
//

//
// $(function() {
//     $('.thrive-spot').hover(function() {
//         $('.thrive-box').fadeIn();
//       },
//       function(){
//         $('.thrive-box').fadeOut();
//       }
//    );
// });


$(document).ready(function(){



    $(".mobile-mission-spot").click(function(){
        $(".mobile-mission-core-hover-box").addClass("mobile-mission-core-hover-box-display");
          $(".circle").addClass("top-bg-hover");
          $(".circle").removeClass("left-bg");
          $(".circle").removeClass("right-bg");
        $("span.mobile-leading-spot").removeClass("bold-mobile-text");
        $("span.mobile-agile-spot").removeClass("bold-mobile-text");
        $("span.mobile-fun-spot").removeClass("bold-mobile-text");
        $("span.mobile-del-spot").removeClass("bold-mobile-text");
        $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
        $("span.mobile-fier-spot").removeClass("bold-mobile-text");
        $("span.mobile-resp-spot").removeClass("bold-mobile-text");
        $(".mobile-lead-core-hover-box").removeClass("mobile-lead-core-hover-box-display");
        $(".mobile-agile-core-hover-box").removeClass("mobile-agile-core-hover-box-display");
        $(".mobile-resp-core-hover-box").removeClass("mobile-resp-core-hover-box-display");
        $(".mobile-fun-core-hover-box").removeClass("mobile-fun-core-hover-box-display");
        $(".mobile-del-core-hover-box").removeClass("mobile-del-core-hover-box-display");
        $(".mobile-thrive-core-hover-box").removeClass("mobile-thrive-core-hover-box-display");
        $(".mobile-fier-core-hover-box").removeClass("mobile-fier-core-hover-box-display");
    });

    $(".mobile-leading-spot").click(function(){
        $(".mobile-lead-core-hover-box").addClass("mobile-lead-core-hover-box-display");
        $(".mobile-agile-core-hover-box").removeClass("mobile-agile-core-hover-box-display");
        $(".mobile-mission-core-hover-box").removeClass("mobile-mission-core-hover-box-display");
        $(".mobile-resp-core-hover-box").removeClass("mobile-resp-core-hover-box-display");
        $(".mobile-fun-core-hover-box").removeClass("mobile-fun-core-hover-box-display");
        $(".mobile-del-core-hover-box").removeClass("mobile-del-core-hover-box-display");
        $(".mobile-thrive-core-hover-box").removeClass("mobile-thrive-core-hover-box-display");
        $(".mobile-fier-core-hover-box").removeClass("mobile-fier-core-hover-box-display");
        $("span.mobile-agile-spot").removeClass("bold-mobile-text");
        $("span.mobile-fun-spot").removeClass("bold-mobile-text");
        $("span.mobile-del-spot").removeClass("bold-mobile-text");
        $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
        $("span.mobile-fier-spot").removeClass("bold-mobile-text");
        $("span.mobile-resp-spot").removeClass("bold-mobile-text");
    });


    $(".mobile-fun-spot").click(function(){
      $(".mobile-mission-core-hover-box").removeClass("mobile-mission-core-hover-box-display");
        $(".mobile-fun-core-hover-box").addClass("mobile-fun-core-hover-box-display");
        $(".mobile-agile-core-hover-box").removeClass("mobile-agile-core-hover-box-display");
        $(".mobile-resp-core-hover-box").removeClass("mobile-resp-core-hover-box-display");
        $(".mobile-lead-core-hover-box").removeClass("mobile-lead-core-hover-box-display");
        $(".mobile-del-core-hover-box").removeClass("mobile-del-core-hover-box-display");
        $(".mobile-thrive-core-hover-box").removeClass("mobile-thrive-core-hover-box-display");
        $(".mobile-fier-core-hover-box").removeClass("mobile-fier-core-hover-box-display");
        $("span.mobile-agile-spot").removeClass("bold-mobile-text");
        $("span.mobile-leading-spot").removeClass("bold-mobile-text");
        $("span.mobile-del-spot").removeClass("bold-mobile-text");
        $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
        $("span.mobile-fier-spot").removeClass("bold-mobile-text");
        $("span.mobile-resp-spot").removeClass("bold-mobile-text");
    });

    $(".mobile-agile-spot").click(function(){
        $(".mobile-agile-core-hover-box").addClass("mobile-agile-core-hover-box-display");
        $(".mobile-mission-core-hover-box").removeClass("mobile-mission-core-hover-box-display");
        $(".mobile-fun-core-hover-box").removeClass("mobile-fun-core-hover-box-display");
        $(".mobile-resp-core-hover-box").removeClass("mobile-resp-core-hover-box-display");
        $(".mobile-lead-core-hover-box").removeClass("mobile-lead-core-hover-box-display");
        $(".mobile-del-core-hover-box").removeClass("mobile-del-core-hover-box-display");
        $(".mobile-thrive-core-hover-box").removeClass("mobile-thrive-core-hover-box-display");
        $(".mobile-fier-core-hover-box").removeClass("mobile-fier-core-hover-box-display");
        $("span.mobile-leading-spot").removeClass("bold-mobile-text");
        $("span.mobile-fun-spot").removeClass("bold-mobile-text");
        $("span.mobile-del-spot").removeClass("bold-mobile-text");
        $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
        $("span.mobile-fier-spot").removeClass("bold-mobile-text");
        $("span.mobile-resp-spot").removeClass("bold-mobile-text");
    });

  $(".mobile-resp-spot").click(function(){
      $(".mobile-resp-core-hover-box").addClass("mobile-resp-core-hover-box-display");
      $(".mobile-mission-core-hover-box").removeClass("mobile-mission-core-hover-box-display");
      $(".mobile-agile-core-hover-box").removeClass("mobile-agile-core-hover-box-display");
      $(".mobile-fun-core-hover-box").removeClass("mobile-fun-core-hover-box-display");
      $(".mobile-lead-core-hover-box").removeClass("mobile-lead-core-hover-box-display");
      $(".mobile-del-core-hover-box").removeClass("mobile-del-core-hover-box-display");
      $(".mobile-thrive-core-hover-box").removeClass("mobile-thrive-core-hover-box-display");
      $(".mobile-fier-core-hover-box").removeClass("mobile-fier-core-hover-box-display");
      $("span.mobile-agile-spot").removeClass("bold-mobile-text");
      $("span.mobile-fun-spot").removeClass("bold-mobile-text");
      $("span.mobile-del-spot").removeClass("bold-mobile-text");
      $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
      $("span.mobile-fier-spot").removeClass("bold-mobile-text");
      $("span.mobile-leading-spot").removeClass("bold-mobile-text");
  });

  $(".mobile-del-spot").click(function(){
      $(".mobile-del-core-hover-box").addClass("mobile-del-core-hover-box-display");
      $(".mobile-resp-core-hover-box").removeClass("mobile-resp-core-hover-box-display");
      $(".mobile-mission-core-hover-box").removeClass("mobile-mission-core-hover-box-display");
      $(".mobile-agile-core-hover-box").removeClass("mobile-agile-core-hover-box-display");
      $(".mobile-fun-core-hover-box").removeClass("mobile-fun-core-hover-box-display");
      $(".mobile-lead-core-hover-box").removeClass("mobile-lead-core-hover-box-display");
      $(".mobile-fier-core-hover-box").removeClass("mobile-fier-core-hover-box-display");
      $(".mobile-thrive-core-hover-box").removeClass("mobile-thrive-core-hover-box-display");
      $("span.mobile-agile-spot").removeClass("bold-mobile-text");
      $("span.mobile-fun-spot").removeClass("bold-mobile-text");
      $("span.mobile-leading-spot").removeClass("bold-mobile-text");
      $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
      $("span.mobile-fier-spot").removeClass("bold-mobile-text");
      $("span.mobile-resp-spot").removeClass("bold-mobile-text");
  });
  $(".mobile-fier-spot").click(function(){
      $(".mobile-fier-core-hover-box").addClass("mobile-fier-core-hover-box-display");
      $(".mobile-resp-core-hover-box").removeClass("mobile-resp-core-hover-box-display");
      $(".mobile-agile-core-hover-box").removeClass("mobile-agile-core-hover-box-display");
      $(".mobile-mission-core-hover-box").removeClass("mobile-mission-core-hover-box-display");
      $(".mobile-fun-core-hover-box").removeClass("mobile-fun-core-hover-box-display");
      $(".mobile-lead-core-hover-box").removeClass("mobile-lead-core-hover-box-display");
      $(".mobile-del-core-hover-box").removeClass("mobile-del-core-hover-box-display");
      $(".mobile-thrive-core-hover-box").removeClass("mobile-thrive-core-hover-box-display");
      $("span.mobile-agile-spot").removeClass("bold-mobile-text");
      $("span.mobile-fun-spot").removeClass("bold-mobile-text");
      $("span.mobile-del-spot").removeClass("bold-mobile-text");
      $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
      $("span.mobile-leading-spot").removeClass("bold-mobile-text");
      $("span.mobile-resp-spot").removeClass("bold-mobile-text");
  });
  $(".mobile-thrive-spot").click(function(){
      $(".mobile-thrive-core-hover-box").addClass("mobile-thrive-core-hover-box-display");
      $(".mobile-resp-core-hover-box").removeClass("mobile-resp-core-hover-box-display");
      $(".mobile-agile-core-hover-box").removeClass("mobile-agile-core-hover-box-display");
      $(".mobile-mission-core-hover-box").removeClass("mobile-mission-core-hover-box-display");
      $(".mobile-fun-core-hover-box").removeClass("mobile-fun-core-hover-box-display");
      $(".mobile-lead-core-hover-box").removeClass("mobile-lead-core-hover-box-display");
      $(".mobile-del-core-hover-box").removeClass("mobile-del-core-hover-box-display");
      $(".mobile-fier-core-hover-box").removeClass("mobile-fier-core-hover-box-display");
      $("span.mobile-agile-spot").removeClass("bold-mobile-text");
      $("span.mobile-fun-spot").removeClass("bold-mobile-text");
      $("span.mobile-del-spot").removeClass("bold-mobile-text");
      $("span.mobile-leading-spot").removeClass("bold-mobile-text");
      $("span.mobile-fier-spot").removeClass("bold-mobile-text");
      $("span.mobile-resp-spot").removeClass("bold-mobile-text");
  });

  // $(".mobile-leading-spot").click(function(){
  //     $(".mobile-leading-core-hover-box").toggleClass("mobile-leading-core-hover-box-display");
  // });
  // $(".mobile-resp-spot").click(function(){
  //     $(".mobile-resp-core-hover-box").toggleClass("mobile-resp-core-hover-box-display");
  // });

  // $(".leading-spot").click(function(){
  //     $(".lead-core-hover-box").toggleClass("line-animate");
  //     $(".lead-hover-text").toggleClass("core-fade-up"); //Toggle the active class to the area is hovered
  //     $(".hover-notice").toggleClass("core-fade-out"); //Toggle the active class to the area is hovered
  // });
  //
  // $(".agile-spot").click(function(){
  //     $(".agile-core-hover-box").toggleClass("line-animate");
  //     $(".agile-hover-text").toggleClass("core-fade-up"); //Toggle the active class to the area is hovered
  //     $(".hover-notice").toggleClass("core-fade-out"); //Toggle the active class to the area is hovered
  // });

  $(".leading-spot").click(function(){
    $(".circle").addClass("left-bg");
    $(".circle").removeClass("right-bg");
      $(".circle").removeClass("top-bg-hover");
      $(".lead-core-hover-box").addClass("line-animate");
      $(".lead-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");
        $(".resp-core-hover-box").removeClass("line-animate");
        $(".resp-hover-text").removeClass("core-fade-up");
        $(".fun-core-hover-box").removeClass("line-animate");
        $(".fun-hover-text").removeClass("core-fade-up");
        $(".del-core-hover-box").removeClass("line-animate");
        $(".del-hover-text").removeClass("core-fade-up");
        $(".fier-core-hover-box").removeClass("line-animate");
        $(".fier-hover-text").removeClass("core-fade-up")
        $(".thrive-core-hover-box").removeClass("line-animate");
        $(".thrive-hover-text").removeClass("core-fade-up");
        $(".agile-core-hover-box").removeClass("line-animate");
        $(".agile-hover-text").removeClass("core-fade-up");
        $(".header").removeClass("core-fade-up");
  });
  $(".agile-spot").click(function(){
      $(".agile-core-hover-box").addClass("line-animate");
      $(".agile-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");
      $(".circle").addClass("left-bg");
      $(".circle").removeClass("right-bg");
      $(".circle").removeClass("top-bg-hover");
        $(".lead-core-hover-box").removeClass("line-animate");
        $(".lead-hover-text").removeClass("core-fade-up");
        $(".resp-core-hover-box").removeClass("line-animate");
        $(".resp-hover-text").removeClass("core-fade-up");
        $(".fun-core-hover-box").removeClass("line-animate");
        $(".fun-hover-text").removeClass("core-fade-up");
        $(".del-core-hover-box").removeClass("line-animate");
        $(".del-hover-text").removeClass("core-fade-up");
        $(".fier-core-hover-box").removeClass("line-animate");
        $(".fier-hover-text").removeClass("core-fade-up");
        $(".thrive-core-hover-box").removeClass("line-animate");
        $(".thrive-hover-text").removeClass("core-fade-up");
  });

  $(".resp-spot").click(function(){
      $(".resp-core-hover-box").addClass("line-animate");
      $(".resp-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");
      $(".circle").addClass("left-bg");
      $(".circle").removeClass("right-bg");
      $(".circle").removeClass("top-bg-hover");
        $(".lead-core-hover-box").removeClass("line-animate");
        $(".lead-hover-text").removeClass("core-fade-up");
        $(".agile-core-hover-box").removeClass("line-animate");
        $(".agile-hover-text").removeClass("core-fade-up");
        $(".fun-core-hover-box").removeClass("line-animate");
        $(".fun-hover-text").removeClass("core-fade-up");
        $(".del-core-hover-box").removeClass("line-animate");
        $(".del-hover-text").removeClass("core-fade-up");
        $(".fier-core-hover-box").removeClass("line-animate");
        $(".fier-hover-text").removeClass("core-fade-up");
        $(".thrive-core-hover-box").removeClass("line-animate");
        $(".thrive-hover-text").removeClass("core-fade-up");
  });
  $(".fun-spot").click(function(){
      $(".fun-core-hover-box").addClass("line-animate");
      $(".fun-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");
      $(".circle").addClass("left-bg");
      $(".circle").removeClass("right-bg");
      $(".circle").removeClass("top-bg-hover");
        $(".lead-core-hover-box").removeClass("line-animate");
        $(".lead-hover-text").removeClass("core-fade-up");
        $(".agile-core-hover-box").removeClass("line-animate");
        $(".agile-hover-text").removeClass("core-fade-up");
        $(".resp-core-hover-box").removeClass("line-animate");
        $(".resp-hover-text").removeClass("core-fade-up");
        $(".del-core-hover-box").removeClass("line-animate");
        $(".del-hover-text").removeClass("core-fade-up");
        $(".fier-core-hover-box").removeClass("line-animate");
        $(".fier-hover-text").removeClass("core-fade-up");
        $(".thrive-core-hover-box").removeClass("line-animate");
        $(".thrive-hover-text").removeClass("core-fade-up");
  });


  $(".del-spot").click(function(){
      $(".del-core-hover-box").addClass("line-animate");
      $(".del-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");
      $(".circle").addClass("right-bg");
      $(".circle").removeClass("left-bg");
      $(".circle").removeClass("top-bg-hover");
        $(".lead-core-hover-box").removeClass("line-animate");
        $(".lead-hover-text").removeClass("core-fade-up");
        $(".agile-core-hover-box").removeClass("line-animate");
        $(".agile-hover-text").removeClass("core-fade-up");
        $(".resp-core-hover-box").removeClass("line-animate");
        $(".resp-hover-text").removeClass("core-fade-up");
        $(".fun-core-hover-box").removeClass("line-animate");
        $(".fun-hover-text").removeClass("core-fade-up");
        $(".fier-core-hover-box").removeClass("line-animate");
        $(".fier-hover-text").removeClass("core-fade-up");
        $(".thrive-core-hover-box").removeClass("line-animate");
        $(".thrive-hover-text").removeClass("core-fade-up");
  });

  $(".fier-spot").click(function(){
      $(".fier-core-hover-box").addClass("line-animate");
      $(".fier-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");
      $(".circle").addClass("right-bg");
      $(".circle").removeClass("left-bg");
      $(".circle").removeClass("top-bg-hover");
        $(".lead-core-hover-box").removeClass("line-animate");
        $(".lead-hover-text").removeClass("core-fade-up");
        $(".agile-core-hover-box").removeClass("line-animate");
        $(".agile-hover-text").removeClass("core-fade-up");
        $(".resp-core-hover-box").removeClass("line-animate");
        $(".resp-hover-text").removeClass("core-fade-up");
        $(".fun-core-hover-box").removeClass("line-animate");
        $(".fun-hover-text").removeClass("core-fade-up");
        $(".del-core-hover-box").removeClass("line-animate");
        $(".del-hover-text").removeClass("core-fade-up");
        $(".thrive-core-hover-box").removeClass("line-animate");
        $(".thrive-hover-text").removeClass("core-fade-up");
  });

  $(".thrive-spot").click(function(){
      $(".thrive-core-hover-box").addClass("line-animate");
      $(".thrive-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");
      $(".circle").addClass("right-bg");
      $(".circle").removeClass("left-bg");
      $(".circle").removeClass("top-bg-hover");
        $(".lead-core-hover-box").removeClass("line-animate");
        $(".lead-hover-text").removeClass("core-fade-up");
        $(".agile-core-hover-box").removeClass("line-animate");
        $(".agile-hover-text").removeClass("core-fade-up");
        $(".resp-core-hover-box").removeClass("line-animate");
        $(".resp-hover-text").removeClass("core-fade-up");
        $(".fun-core-hover-box").removeClass("line-animate");
        $(".fun-hover-text").removeClass("core-fade-up");
        $(".del-core-hover-box").removeClass("line-animate");
        $(".del-hover-text").removeClass("core-fade-up");
        $(".fier-core-hover-box").removeClass("line-animate");
        $(".fier-hover-text").removeClass("core-fade-up");
  });

  $(".mission-spot").click(function(){
      $(".mission-core-hover-box").addClass("line-animate");
      $(".mission-hover-text").addClass("core-fade-up");
      $(".hover-notice").addClass("core-fade-out");

      $(".circle").addClass("top-bg-hover");
      $(".circle").removeClass("left-bg");
      $(".circle").removeClass("right-bg");
        $(".lead-core-hover-box").removeClass("line-animate");
        $(".lead-hover-text").removeClass("core-fade-up");
        $(".thrive-core-hover-box").removeClass("line-animate");
        $(".thrive-hover-text").removeClass("core-fade-up");
        $(".agile-core-hover-box").removeClass("line-animate");
        $(".agile-hover-text").removeClass("core-fade-up");
        $(".resp-core-hover-box").removeClass("line-animate");
        $(".resp-hover-text").removeClass("core-fade-up");
        $(".fun-core-hover-box").removeClass("line-animate");
        $(".fun-hover-text").removeClass("core-fade-up");
        $(".del-core-hover-box").removeClass("line-animate");
        $(".del-hover-text").removeClass("core-fade-up");
        $(".fier-core-hover-box").removeClass("line-animate");
        $(".fier-hover-text").removeClass("core-fade-up");
        $("span.leading-spot").removeClass("grow-text");
        $("span.agile-spot").removeClass("grow-text")
        $("span.resp-spot").removeClass("grow-text");
        $("span.fun-spot").removeClass("grow-text");
        $("span.del-spot").removeClass("grow-text");
        $("span.fier-spot").removeClass("grow-text");
        $("span.thrive-spot").removeClass("grow-text");
  });


  $("span.leading-spot").click(function(){
  $("span.leading-spot").addClass("grow-text");
    $("span.agile-spot").removeClass("grow-text")
    $("span.resp-spot").removeClass("grow-text");
    $("span.fun-spot").removeClass("grow-text");
    $("span.del-spot").removeClass("grow-text");
    $("span.fier-spot").removeClass("grow-text");
    $("span.thrive-spot").removeClass("grow-text");
    $(".mission-core-hover-box").removeClass("line-animate");
    $(".mission-hover-text").removeClass("core-fade-up");
  });

  $("span.agile-spot").click(function(){
  $("span.agile-spot").addClass("grow-text");
    $("span.leading-spot").removeClass("grow-text");
    $("span.resp-spot").removeClass("grow-text");
    $("span.fun-spot").removeClass("grow-text");
    $("span.del-spot").removeClass("grow-text");
    $("span.fier-spot").removeClass("grow-text");
    $("span.thrive-spot").removeClass("grow-text");
    $(".mission-core-hover-box").removeClass("line-animate");
   $(".mission-hover-text").removeClass("core-fade-up");
  });
  $("span.resp-spot").click(function(){
  $("span.resp-spot").addClass("grow-text");
    $("span.agile-spot").removeClass("grow-text");
    $("span.leading-spot").removeClass("grow-text");
    $("span.fun-spot").removeClass("grow-text");
    $("span.del-spot").removeClass("grow-text");
    $("span.fier-spot").removeClass("grow-text");
    $("span.thrive-spot").removeClass("grow-text");
    $(".mission-core-hover-box").removeClass("line-animate");
    $(".mission-hover-text").removeClass("core-fade-up");
    });
  $("span.fun-spot").click(function(){
  $("span.fun-spot").addClass("grow-text");
    $("span.agile-spot").removeClass("grow-text");
    $("span.leading-spot").removeClass("grow-text");
    $("span.del-spot").removeClass("grow-text");
    $("span.fier-spot").removeClass("grow-text");
    $("span.thrive-spot").removeClass("grow-text");
    $("span.resp-spot").removeClass("grow-text");
    $(".mission-core-hover-box").removeClass("line-animate");
$(".mission-hover-text").removeClass("core-fade-up");
    });

  $("span.del-spot").click(function(){
  $("span.del-spot").addClass("grow-text");
    $("span.agile-spot").removeClass("grow-text");
    $("span.leading-spot").removeClass("grow-text");
    $("span.fun-spot").removeClass("grow-text");
    $("span.fier-spot").removeClass("grow-text");
    $("span.thrive-spot").removeClass("grow-text");
    $("span.resp-spot").removeClass("grow-text");
    $(".mission-core-hover-box").removeClass("line-animate");
$(".mission-hover-text").removeClass("core-fade-up");
  });
  $("span.fier-spot").click(function(){
  $("span.fier-spot").addClass("grow-text");
    $("span.agile-spot").removeClass("grow-text");
    $("span.leading-spot").removeClass("grow-text");
    $("span.fun-spot").removeClass("grow-text");
    $("span.thrive-spot").removeClass("grow-text");
    $("span.resp-spot").removeClass("grow-text")
    $("span.del-spot").removeClass("grow-text");
    $(".mission-core-hover-box").removeClass("line-animate");
$(".mission-hover-text").removeClass("core-fade-up");
    });
  $("span.thrive-spot").click(function(){
  $("span.thrive-spot").addClass("grow-text");
    $("span.agile-spot").removeClass("grow-text");
    $("span.leading-spot").removeClass("grow-text");
    $("span.fun-spot").removeClass("grow-text");
    $("span.fier-spot").removeClass("grow-text");
    $("span.resp-spot").removeClass("grow-text")
    $("span.del-spot").removeClass("grow-text");
    $(".mission-core-hover-box").removeClass("line-animate");
$(".mission-hover-text").removeClass("core-fade-up");
    });

  $("span.mobile-resp-spot").click(function(){
  $("span.mobile-resp-spot").addClass("bold-mobile-text");
  $(".circle").addClass("left-bg");
  $(".circle").removeClass("right-bg");
    $(".circle").removeClass("top-bg-hover");
    $("span.mobile-leading-spot").removeClass("bold-mobile-text");
    $("span.mobile-agile-spot").removeClass("bold-mobile-text");
    $("span.mobile-fun-spot").removeClass("bold-mobile-text");
    $("span.mobile-del-spot").removeClass("bold-mobile-text");
    $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
    $("span.mobile-fier-spot").removeClass("bold-mobile-text");
    });

  $("span.mobile-leading-spot").click(function(){
  $("span.mobile-leading-spot").addClass("bold-mobile-text");
  $(".circle").addClass("left-bg");
  $(".circle").removeClass("right-bg");
    $(".circle").removeClass("top-bg-hover");
    $("span.mobile-resp-spot").removeClass("bold-mobile-text");
    $("span.mobile-agile-spot").removeClass("bold-mobile-text");
    $("span.mobile-fun-spot").removeClass("bold-mobile-text");
    $("span.mobile-del-spot").removeClass("bold-mobile-text");
    $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
    $("span.mobile-fier-spot").removeClass("bold-mobile-text");
    });
  $("span.mobile-agile-spot").click(function(){
    $("span.mobile-agile-spot").addClass("bold-mobile-text");
    $(".circle").addClass("left-bg");
    $(".circle").removeClass("right-bg");
      $(".circle").removeClass("top-bg-hover");
    $("span.mobile-resp-spot").removeClass("bold-mobile-text")
    $("span.mobile-fun-spot").removeClass("bold-mobile-text");
    $("span.mobile-del-spot").removeClass("bold-mobile-text");
    $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
    $("span.mobile-leading-spot").removeClass("bold-mobile-text");
    $("span.mobile-fier-spot").removeClass("bold-mobile-text");

    });
  $("span.mobile-fun-spot").click(function(){
  $("span.mobile-fun-spot").addClass("bold-mobile-text");
    $("span.mobile-leading-spot").removeClass("bold-mobile-text");
    $(".circle").addClass("left-bg");
    $(".circle").removeClass("right-bg");
      $(".circle").removeClass("top-bg-hover");
    $("span.mobile-resp-spot").removeClass("bold-mobile-text")
    $("span.mobile-agile-spot").removeClass("bold-mobile-text");
    $("span.mobile-del-spot").removeClass("bold-mobile-text");
    $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
    $("span.mobile-fier-spot").removeClass("bold-mobile-text");
    });

  $("span.mobile-del-spot").click(function(){
  $("span.mobile-del-spot").addClass("bold-mobile-text");
  $("span.mobile-fier-spot").removeClass("bold-mobile-text");
  $(".circle").addClass("right-bg");
  $(".circle").removeClass("left-bg");
    $(".circle").removeClass("top-bg-hover");
    $("span.mobile-leading-spot").removeClass("bold-mobile-text");
    $("span.mobile-resp-spot").removeClass("bold-mobile-text")
    $("span.mobile-agile-spot").removeClass("bold-mobile-text");
    $("span.mobile-fun-spot").removeClass("bold-mobile-text");
    $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
    });
  $("span.mobile-thrive-spot").click(function(){
  $("span.mobile-thrive-spot").addClass("bold-mobile-text");
  $(".circle").addClass("right-bg");
  $(".circle").removeClass("left-bg");
    $(".circle").removeClass("top-bg-hover");
    $("span.mobile-leading-spot").removeClass("bold-mobile-text");
    $("span.mobile-resp-spot").removeClass("bold-mobile-text")
    $("span.mobile-agile-spot").removeClass("bold-mobile-text");
    $("span.mobile-fun-spot").removeClass("bold-mobile-text");
    $("span.mobile-fier-spot").removeClass("bold-mobile-text");
    $("span.mobile-del-spot").removeClass("bold-mobile-text");
    });
  $("span.mobile-fier-spot").click(function(){
  $("span.mobile-fier-spot").addClass("bold-mobile-text");
  $("span.mobile-thrive-spot").removeClass("bold-mobile-text");
  $("span.mobile-del-spot").removeClass("bold-mobile-text");
  $(".circle").addClass("right-bg");
  $(".circle").removeClass("left-bg");
    $(".circle").removeClass("top-bg-hover");
    $("span.mobile-leading-spot").removelass("bold-mobile-text");
    $("span.mobile-resp-spot").removeClass("bold-mobile-text")
    $("span.mobile-agile-spot").removeClass("bold-mobile-text");
    $("span.mobile-fun-spot").removeClass("bold-mobile-text");
    });

    // $("span.thrive-spot").hover(function(){
    // $("span.thrive-spot").addClass("grow-text");
    // $("span.fier-spot").removeClass("grow-text");
    // });
    //
    // $("span.fier-spot").hover(function(){
    // $("span.fier-spot").addClass("grow-text");
    // $("span.thrive-spot").removeClass("grow-text");
    // });
    //
    // $("span.del-spot").hover(function(){
    // $("span.del-spot").addClass("grow-text");
    // $("span.thrive-spot").removeClass("grow-text");
    // $("span.fier-spot").removeClass("grow-text");
    // });

    // $("span.fun-spot").hover(function(){
    // $("span.fun-spot").addClass("grow-text");
    //   $("span.thrive-spot").removeClass("grow-text");
    //   $("span.fier-spot").removeClass("grow-text");
    //   $("span.resp-spot").removeClass("grow-text");
    //   $("span.agile-spot").removeClass("grow-text");
    //   $("span.lead-spot").removeClass("grow-text");
    //   $("span.del-spot").removeClass("grow-text");
    // });
    // $("span.resp-spot").hover(function(){
    // $("span.resp-spot").addClass("grow-text");
    //   $("span.thrive-spot").removeClass("grow-text");
    //   $("span.fier-spot").removeClass("grow-text");
    //   $("span.fun-spot").removeClass("grow-text");
    //   $("span.del-spot").removeClass("grow-text");
    //   $("span.agile-spot").removeClass("grow-text");
    //   $("span.lead-spot").removeClass("grow-text");
    // });
    // $("span.agile-spot").hover(function(){
    // $("span.agile-spot").addClass("grow-text");
    //   $("span.thrive-spot").removeClass("grow-text");
    //   $("span.fier-spot").removeClass("grow-text");
    //   $("span.fun-spot").removeClass("grow-text");
    //   $("span.resp-spot").removeClass("grow-text");
    //   $("span.lead-spot").removeClass("grow-text");
    //   $("span.del-spot").removeClass("grow-text");
    // });
    // $("span.lead-spot").hover(function(){
    // $("span.lead-spot").addClass("grow-text");
    //   $("span.thrive-spot").removeClass("grow-text");
    //   $("span.fier-spot").removeClass("grow-text");
    //   $("span.del-spot").removeClass("grow-text");
    //   $("span.fun-spot").removeClass("grow-text");
    //   $("span.resp-spot").removeClass("grow-text");
    //   $("span.agile-spot").removeClass("grow-text");
    // });

  // $(".left-text").hover(function(){
  //     $(".circle").toggleClass("left-bg");  //Toggle the active class to the area is hovered
  // });
  //
  // $(".right-text").hover(function(){
  //     $(".circle").toggleClass("right-bg");  //Toggle the active class to the area is hovered
  // });
  //
  // $(".top-text").hover(function(){
  //     $(".circle").toggleClass("top-bg-hover");  //Toggle the active class to the area is hovered
  // });

$("#name").on('change',function(){
  $(".data").hide();
  $("#" + $(this).val()).fadeIn(700);
}).change();




});


// advanced template, custom svg block, make svg responsive

$(window).on("resize", function () {
  var myWidth = $('.svg-container').width();
  var myHeight = (myWidth * 1047/2042); // height/width
  $('.svg-container svg').css('width', myWidth + 'px');
  $('.svg-container svg').css('height', myHeight + 'px');
}).resize();


// advanced template, custom svg block, waypoints setup

$('.custom-svg-block #text-two').waypoint(function(direction) {
  if (direction ==='down') {

    $('.custom-svg-block #text-two').addClass('animate');
    $('.custom-svg-block #arrows-two').addClass('animate');
    $('.custom-svg-block #highlight-two').addClass('animate');

  } else {

    //$('.custom-svg-block #text-two').removeClass('animate');
    //$('.custom-svg-block #arrows-two').removeClass('animate');
    //$('.custom-svg-block #highlight-two').removeClass('animate');

  }
}, {
  offset: '70%'
});

$('.custom-svg-block #text-three').waypoint(function(direction) {
  if (direction ==='down') {

    $('.custom-svg-block #text-three').addClass('animate');
    $('.custom-svg-block #arrows-three').addClass('animate');

  } else {

    //$('.custom-svg-block #text-three').removeClass('animate');
    //$('.custom-svg-block #arrows-three').removeClass('animate');

  }
}, {
  offset: '70%'
});

$('.custom-svg-block #text-one').waypoint(function(direction) {
  if (direction ==='down') {

    $('.custom-svg-block #text-one').addClass('animate');
    $('.custom-svg-block #arrows-one').addClass('animate');
    $('.custom-svg-block #highlight-one').addClass('animate');

  } else {

    //$('.custom-svg-block #text-one').removeClass('animate');
    //$('.custom-svg-block #arrows-one').removeClass('animate');
    //$('.custom-svg-block #highlight-one').removeClass('animate');

  }
}, {
  offset: '60%'
});

$('.custom-svg-block #text-four').waypoint(function(direction) {
  if (direction ==='down') {

    $('.custom-svg-block #text-four').addClass('animate');
    $('.custom-svg-block #arrows-four').addClass('animate');
    $('.custom-svg-block #highlight-four').addClass('animate');

  } else {

    //$('.custom-svg-block #text-four').removeClass('animate');
    //$('.custom-svg-block #arrows-four').removeClass('animate');
    //$('.custom-svg-block #highlight-four').removeClass('animate');

  }
}, {
  offset: '50%'
});

$('.custom-svg-block #text-five').waypoint(function(direction) {
  if (direction ==='down') {

    $('.custom-svg-block #text-five').addClass('animate');
    $('.custom-svg-block #arrows-five').addClass('animate');
    $('.custom-svg-block #highlight-five').addClass('animate');

  } else {

    //$('.custom-svg-block #text-five').removeClass('animate');
    //$('.custom-svg-block #arrows-five').removeClass('animate');
    //$('.custom-svg-block #highlight-five').removeClass('animate');

  }
}, {
  offset: '70%'
});

$('.custom-svg-block #text-six').waypoint(function(direction) {
  if (direction ==='down') {

    $('.custom-svg-block #text-six').addClass('animate');
    $('.custom-svg-block #arrows-six').addClass('animate');

  } else {

    //$('.custom-svg-block #text-six').removeClass('animate');
    //$('.custom-svg-block #arrows-six').removeClass('animate');

  }
}, {
  offset: '80%'
});



})(jQuery);
